import { Tc, PagingResultsViewModel } from "../../../core/_infrastructure/types/common";


export class MrnItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: TPreduaMantenimientoViewModel [];
}

export class TPreduaMantenimientoViewModel {
    public Mrn: string = '';
    public IdOperacion: number;
    public FechaPresentacion: Date;
    public NombreExportador: string;
    public IdPaisExportador: number;
    public PaisExportador: string;
    public CiudadExportador: string;
    public DireccionExportador: string;
    public IdPif: number;
    public IdPifDescripcion: string;
    public IdAduanaDespacho: number;
    public IdAduanaDespachoDescripcion: string;
    public IdentificadorImportador: string;
    public RazonSocialImportador: string;
    public DireccionImportador: string;
    public IdPaisDestino: number;
    public PaisDestino: string;
    public IdPaisOrigen: number;
    public PaisOrigen: string;
    public IdMedioTransporte: number;
    public MedioTransporte: string;
    public FechaCreacion: Date;
    public FechaModificacion: Date;
    public FechaImportacion: Date;
    public IdBandejaEntrada: number;
    //public IdEstadoSolicitud: number;
    //public IdEstadoSolicitudDescripcion: string;
    //public IdTipoSolicitudDescripcion: string;
    //public CodigoTipoSolicitud: string;
    //public CodigoSolicitud: string;
    //public EsPredua: boolean;

    public TPartidasPreduaList: TPartidaPreduaMantenimientoViewModel[];
    public TPosicionamientoPreduaList: TPosicionamientoPreduaMantenimientoViewModel[];
}

export class TPartidaPreduaMantenimientoViewModel {
    public Id: number;
    public Partida: string = '';
    public CodigoTaric: string = '';
    public PaisOrigen: string = '';
    public IdPaisOrigen: number;
    public PesoNeto: number | null = null;

    public MatriculasList: TPartidaPreduaEquipamientoMantenimientoViewModel[];

    //campos para el grid
    //public Acumulado: number;
    //public strMatriculas: string = '';
       
}


export class TPartidaPreduaEquipamientoMantenimientoViewModel {
    //public Id: number;
    //public IdPartidaPredua: number;
    public Matricula: string = '';
}


export class TPosicionamientoPreduaMantenimientoViewModel {
    public Matricula: string = '';
    public FechaAutorizacion: Date;
}


export class FilterSearchingMrnViewModel {    
    public Mrn: string = '';    
}





